import { storableError } from '../../util/errors';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import {
  getStoreBlogsByUserId,
  generateStoreBlogTitleswithLabels,
  generateStoreBlogs,
  getBlogsByListingId,
  updateStoreBlogsPost,
  updateStoreBlogPost,
  updateBlogPost,
  createStoreBlogPost,
  createStoreBlogPostApi,
  publishStoreBlogPost,
  deleteStoreBlogPostApi,
  retryStoreBlogTranslations,
} from '../../util/api';
import { buildStoreBlogSlug, getStoreBlogSlug } from '../../util/storeBlogs';

// ================ Action types ================ //

export const UPDATE_STORE_BLOG_REQUEST =
  'app/StoreBlogPage/UPDATE_STORE_BLOG_REQUEST';
export const UPDATE_STORE_BLOG_SUCCESS =
  'app/StoreBlogPage/UPDATE_STORE_BLOG_SUCCESS';
export const UPDATE_STORE_BLOG_ERROR =
  'app/StoreBlogPage/UPDATE_STORE_BLOG_ERROR';

export const FETCH_USER_LISTINGS_REQUEST =
  'app/StoreBlogPage/FETCH_USER_LISTINGS_REQUEST';
export const FETCH_USER_LISTINGS_SUCCESS =
  'app/StoreBlogPage/FETCH_USER_LISTINGS_SUCCESS';
export const FETCH_USER_LISTINGS_ERROR =
  'app/StoreBlogPage/FETCH_USER_LISTINGS_ERROR';

export const FETCH_LISTING_BLOGS_REQUEST =
  'app/StoreBlogPage/FETCH_LISTING_BLOGS_REQUEST';
export const FETCH_LISTING_BLOGS_SUCCESS =
  'app/StoreBlogPage/FETCH_LISTING_BLOGS_SUCCESS';
export const FETCH_LISTING_BLOGS_ERROR =
  'app/StoreBlogPage/FETCH_LISTING_BLOGS_ERROR';

export const FETCH_STORE_BLOGS_REQUEST =
  'app/StoreBlogPage/FETCH_STORE_BLOGS_REQUEST';
export const FETCH_STORE_BLOGS_SUCCESS =
  'app/StoreBlogPage/FETCH_STORE_BLOGS_SUCCESS';
export const FETCH_STORE_BLOGS_ERROR =
  'app/StoreBlogPage/FETCH_STORE_BLOGS_ERROR';

export const FETCH_STORE_BLOGS_ANALYTICS_SUCCESS =
  'app/StoreBlogPage/FETCH_STORE_BLOGS_ANALYTICS_SUCCESS';

export const GENERATE_BLOG_TITLES_REQUEST =
  'app/StoreBlogPage/GENERATE_BLOG_TITLES_REQUEST';
export const GENERATE_BLOG_TITLES_SUCCESS =
  'app/StoreBlogPage/GENERATE_BLOG_TITLES_SUCCESS';
export const GENERATE_BLOG_TITLES_ERROR =
  'app/StoreBlogPage/GENERATE_BLOG_TITLES_ERROR';

export const GENERATE_BLOGS_REQUEST =
  'app/StoreBlogPage/GENERATE_BLOGS_REQUEST';
export const GENERATE_BLOGS_SUCCESS =
  'app/StoreBlogPage/GENERATE_BLOGS_SUCCESS';
export const GENERATE_BLOGS_ERROR = 'app/StoreBlogPage/GENERATE_BLOGS_ERROR';

export const UPDATE_BLOG_REQUEST = 'app/StoreBlogPage/UPDATE_BLOG_REQUEST';
export const UPDATE_BLOG_SUCCESS = 'app/StoreBlogPage/UPDATE_BLOG_SUCCESS';
export const UPDATE_BLOG_ERROR = 'app/StoreBlogPage/UPDATE_BLOG_ERROR';

export const DELETE_BLOG_REQUEST = 'app/StoreBlogPage/DELETE_BLOG_REQUEST';
export const DELETE_BLOG_SUCCESS = 'app/StoreBlogPage/DELETE_BLOG_SUCCESS';
export const DELETE_BLOG_ERROR = 'app/StoreBlogPage/DELETE_BLOG_ERROR';

export const PUBLISH_BLOG_REQUEST = 'app/StoreBlogPage/PUBLISH_BLOG_REQUEST';
export const PUBLISH_BLOG_SUCCESS = 'app/StoreBlogPage/PUBLISH_BLOG_SUCCESS';
export const PUBLISH_BLOG_ERROR = 'app/StoreBlogPage/PUBLISH_BLOG_ERROR';

export const RETRY_STORE_BLOG_TRANSLATIONS_REQUEST =
  'app/StoreBlogPage/RETRY_STORE_BLOG_TRANSLATIONS_REQUEST';
export const RETRY_STORE_BLOG_TRANSLATIONS_SUCCESS =
  'app/StoreBlogPage/RETRY_STORE_BLOG_TRANSLATIONS_SUCCESS';
export const RETRY_STORE_BLOG_TRANSLATIONS_ERROR =
  'app/StoreBlogPage/RETRY_STORE_BLOG_TRANSLATIONS_ERROR';

export const UPDATE_LISTING_BLOGS_REQUEST =
  'app/StoreBlogPage/UPDATE_LISTING_BLOGS_REQUEST';
export const UPDATE_LISTING_BLOGS_SUCCESS =
  'app/StoreBlogPage/UPDATE_LISTING_BLOGS_SUCCESS';
export const UPDATE_LISTING_BLOGS_ERROR =
  'app/StoreBlogPage/UPDATE_LISTING_BLOGS_ERROR';

export const CREATE_BLOG_REQUEST = 'app/StoreBlogPage/CREATE_BLOG_REQUEST';
export const CREATE_BLOG_SUCCESS = 'app/StoreBlogPage/CREATE_BLOG_SUCCESS';
export const CREATE_BLOG_ERROR = 'app/StoreBlogPage/CREATE_BLOG_ERROR';

// ================ Reducer ================ //

const initialState = {
  updateInProgress: false,
  updateError: null,
  fetchUserListingsInProgress: false,
  fetchUserListingsError: null,
  userListings: [],
  fetchListingBlogsInProgress: false,
  fetchListingBlogsError: null,
  listingBlogs: [],
  fetchStoreBlogsInProgress: false,
  fetchStoreBlogsError: null,
  storeBlogs: [],
  storeBlogsAnalytics: null,
  generateBlogTitlesInProgress: false,
  generateBlogTitlesError: null,
  blogTitles: [],
  generateBlogsInProgress: false,
  generateBlogsError: null,
  generatedBlogs: [],
  updateBlogInProgress: {},
  updateBlogError: {},
  deleteBlogInProgress: {},
  deleteBlogError: {},
  publishBlogInProgress: {},
  publishBlogError: {},
  retryTranslationsInProgress: {},
  retryTranslationsStatus: {},
  retryTranslationsError: {},
  updateListingBlogsInProgress: false,
  updateListingBlogsError: null,
  createBlogInProgress: false,
  createBlogError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_STORE_BLOG_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateError: null,
      };
    case UPDATE_STORE_BLOG_SUCCESS:
      return {
        ...state,
        updateInProgress: false,
        updateError: null,
      };
    case UPDATE_STORE_BLOG_ERROR:
      return {
        ...state,
        updateInProgress: false,
        updateError: payload,
      };
    case FETCH_USER_LISTINGS_REQUEST:
      return {
        ...state,
        fetchUserListingsInProgress: true,
        fetchUserListingsError: null,
      };
    case FETCH_USER_LISTINGS_SUCCESS:
      return {
        ...state,
        fetchUserListingsInProgress: false,
        fetchUserListingsError: null,
        userListings: payload,
      };
    case FETCH_USER_LISTINGS_ERROR:
      return {
        ...state,
        fetchUserListingsInProgress: false,
        fetchUserListingsError: payload,
      };
    case FETCH_LISTING_BLOGS_REQUEST:
      return {
        ...state,
        fetchListingBlogsInProgress: true,
        fetchListingBlogsError: null,
      };
    case FETCH_LISTING_BLOGS_SUCCESS:
      return {
        ...state,
        fetchListingBlogsInProgress: false,
        fetchListingBlogsError: null,
        // The only path by which a fetched value reaches listingBlogs. Initial state is [],
        // so holding the invariant here is what keeps the whole key an array (ticket 91).
        listingBlogs: Array.isArray(payload) ? payload : [],
      };
    case FETCH_LISTING_BLOGS_ERROR:
      return {
        ...state,
        fetchListingBlogsInProgress: false,
        fetchListingBlogsError: payload,
      };
    case FETCH_STORE_BLOGS_REQUEST:
      return {
        ...state,
        fetchStoreBlogsInProgress: true,
        fetchStoreBlogsError: null,
      };
    case FETCH_STORE_BLOGS_SUCCESS:
      return {
        ...state,
        fetchStoreBlogsInProgress: false,
        fetchStoreBlogsError: null,
        storeBlogs: payload,
      };
    case FETCH_STORE_BLOGS_ERROR:
      return {
        ...state,
        fetchStoreBlogsInProgress: false,
        fetchStoreBlogsError: payload,
      };
    case FETCH_STORE_BLOGS_ANALYTICS_SUCCESS:
      return {
        ...state,
        storeBlogsAnalytics: payload,
      };
    case GENERATE_BLOG_TITLES_REQUEST:
      return {
        ...state,
        generateBlogTitlesInProgress: true,
        generateBlogTitlesError: null,
      };
    case GENERATE_BLOG_TITLES_SUCCESS:
      return {
        ...state,
        generateBlogTitlesInProgress: false,
        generateBlogTitlesError: null,
        blogTitles: payload,
      };
    case GENERATE_BLOG_TITLES_ERROR:
      return {
        ...state,
        generateBlogTitlesInProgress: false,
        generateBlogTitlesError: payload,
      };
    case GENERATE_BLOGS_REQUEST:
      return {
        ...state,
        generateBlogsInProgress: true,
        generateBlogsError: null,
      };
    case GENERATE_BLOGS_SUCCESS:
      return {
        ...state,
        generateBlogsInProgress: false,
        generateBlogsError: null,
        generatedBlogs: payload,
      };
    case GENERATE_BLOGS_ERROR:
      return {
        ...state,
        generateBlogsInProgress: false,
        generateBlogsError: payload,
      };
    case UPDATE_BLOG_REQUEST:
      return {
        ...state,
        updateBlogInProgress: {
          ...state.updateBlogInProgress,
          [payload]: true,
        },
        updateBlogError: {
          ...state.updateBlogError,
          [payload]: null,
        },
      };
    case UPDATE_BLOG_SUCCESS:
      return {
        ...state,
        updateBlogInProgress: {
          ...state.updateBlogInProgress,
          [payload._id]: false,
        },
        updateBlogError: {
          ...state.updateBlogError,
          [payload._id]: null,
        },
        storeBlogs: state.storeBlogs.map(blog =>
          blog._id === payload._id ? payload : blog
        ),
      };
    case UPDATE_BLOG_ERROR:
      return {
        ...state,
        updateBlogInProgress: {
          ...state.updateBlogInProgress,
          [payload.id]: false,
        },
        updateBlogError: {
          ...state.updateBlogError,
          [payload.id]: payload.error,
        },
      };
    case DELETE_BLOG_REQUEST:
      return {
        ...state,
        deleteBlogInProgress: {
          ...state.deleteBlogInProgress,
          [payload]: true,
        },
        deleteBlogError: {
          ...state.deleteBlogError,
          [payload]: null,
        },
      };
    case DELETE_BLOG_SUCCESS:
      return {
        ...state,
        deleteBlogInProgress: {
          ...state.deleteBlogInProgress,
          [payload]: false,
        },
        deleteBlogError: {
          ...state.deleteBlogError,
          [payload]: null,
        },
        generatedBlogs: state.generatedBlogs.filter(
          blog => blog.id !== payload
        ),
        storeBlogs: state.storeBlogs.filter(blog => blog._id !== payload),
      };
    case DELETE_BLOG_ERROR:
      return {
        ...state,
        deleteBlogInProgress: {
          ...state.deleteBlogInProgress,
          [payload.id]: false,
        },
        deleteBlogError: {
          ...state.deleteBlogError,
          [payload.id]: payload.error,
        },
      };
    case PUBLISH_BLOG_REQUEST:
      return {
        ...state,
        publishBlogInProgress: {
          ...state.publishBlogInProgress,
          [payload]: true,
        },
        publishBlogError: {
          ...state.publishBlogError,
          [payload]: null,
        },
      };
    case PUBLISH_BLOG_SUCCESS:
      return {
        ...state,
        publishBlogInProgress: {
          ...state.publishBlogInProgress,
          [payload._id]: false,
        },
        publishBlogError: {
          ...state.publishBlogError,
          [payload._id]: null,
        },
        generatedBlogs: state.generatedBlogs.map(blog =>
          blog.id === payload._id ? payload : blog
        ),
        storeBlogs: state.storeBlogs.map(blog =>
          blog._id === payload._id ? payload : blog
        ),
      };
    case PUBLISH_BLOG_ERROR:
      return {
        ...state,
        publishBlogInProgress: {
          ...state.publishBlogInProgress,
          [payload.id]: false,
        },
        publishBlogError: {
          ...state.publishBlogError,
          [payload.id]: payload.error,
        },
      };
    case RETRY_STORE_BLOG_TRANSLATIONS_REQUEST:
      return {
        ...state,
        retryTranslationsInProgress: {
          ...state.retryTranslationsInProgress,
          [payload]: true,
        },
        retryTranslationsStatus: {
          ...state.retryTranslationsStatus,
          [payload]: 'in_progress',
        },
        retryTranslationsError: {
          ...state.retryTranslationsError,
          [payload]: null,
        },
      };
    case RETRY_STORE_BLOG_TRANSLATIONS_SUCCESS:
      return {
        ...state,
        retryTranslationsInProgress: {
          ...state.retryTranslationsInProgress,
          [payload.id]: false,
        },
        retryTranslationsStatus: {
          ...state.retryTranslationsStatus,
          [payload.id]: payload.status || 'completed',
        },
        retryTranslationsError: {
          ...state.retryTranslationsError,
          [payload.id]: null,
        },
        storeBlogs: state.storeBlogs.map(blog =>
          blog._id === payload.id ? payload.blog : blog
        ),
      };
    case RETRY_STORE_BLOG_TRANSLATIONS_ERROR:
      return {
        ...state,
        retryTranslationsInProgress: {
          ...state.retryTranslationsInProgress,
          [payload.id]: false,
        },
        retryTranslationsStatus: {
          ...state.retryTranslationsStatus,
          [payload.id]: 'failed',
        },
        retryTranslationsError: {
          ...state.retryTranslationsError,
          [payload.id]: payload.error,
        },
      };
    case UPDATE_LISTING_BLOGS_REQUEST:
      return {
        ...state,
        updateListingBlogsInProgress: true,
        updateListingBlogsError: null,
      };
    case UPDATE_LISTING_BLOGS_SUCCESS: {
      const updatedBlogsById = (payload || []).reduce((acc, blog) => {
        if (blog && blog._id) {
          acc[blog._id] = blog;
        }
        return acc;
      }, {});

      // Never map over a value that is not an array. The branch above keeps listingBlogs an
      // array, so this is the belt to that braces: a state built any other way cannot turn an
      // owner saving their listing blogs into a crash (ticket 91).
      const current = Array.isArray(state.listingBlogs) ? state.listingBlogs : [];

      return {
        ...state,
        updateListingBlogsInProgress: false,
        updateListingBlogsError: null,
        listingBlogs: current.map(blog =>
          updatedBlogsById[blog._id] ? updatedBlogsById[blog._id] : blog
        ),
      };
    }
    case UPDATE_LISTING_BLOGS_ERROR:
      return {
        ...state,
        updateListingBlogsInProgress: false,
        updateListingBlogsError: payload,
      };
    case CREATE_BLOG_REQUEST:
      return {
        ...state,
        createBlogInProgress: true,
        createBlogError: null,
      };
    case CREATE_BLOG_SUCCESS:
      return {
        ...state,
        createBlogInProgress: false,
        createBlogError: null,
        storeBlogs: [...state.storeBlogs, payload],
      };
    case CREATE_BLOG_ERROR:
      return {
        ...state,
        createBlogInProgress: false,
        createBlogError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const updateStoreBlogRequest = () => ({
  type: UPDATE_STORE_BLOG_REQUEST,
});

export const updateStoreBlogSuccess = () => ({
  type: UPDATE_STORE_BLOG_SUCCESS,
});

export const updateStoreBlogError = error => ({
  type: UPDATE_STORE_BLOG_ERROR,
  payload: error,
});

export const fetchUserListingsRequest = () => ({
  type: FETCH_USER_LISTINGS_REQUEST,
});

export const fetchUserListingsSuccess = listings => ({
  type: FETCH_USER_LISTINGS_SUCCESS,
  payload: listings,
});

export const fetchUserListingsError = error => ({
  type: FETCH_USER_LISTINGS_ERROR,
  payload: error,
});

export const fetchListingBlogsRequest = () => ({
  type: FETCH_LISTING_BLOGS_REQUEST,
});

export const fetchListingBlogsSuccess = blogs => ({
  type: FETCH_LISTING_BLOGS_SUCCESS,
  payload: blogs,
});

export const fetchListingBlogsError = error => ({
  type: FETCH_LISTING_BLOGS_ERROR,
  payload: error,
});

export const fetchStoreBlogsRequest = () => ({
  type: FETCH_STORE_BLOGS_REQUEST,
});

export const fetchStoreBlogsSuccess = blogs => ({
  type: FETCH_STORE_BLOGS_SUCCESS,
  payload: blogs,
});

export const fetchStoreBlogsError = error => ({
  type: FETCH_STORE_BLOGS_ERROR,
  payload: error,
});

export const fetchStoreBlogsAnalyticsSuccess = analytics => ({
  type: FETCH_STORE_BLOGS_ANALYTICS_SUCCESS,
  payload: analytics,
});

export const generateBlogTitlesRequest = () => ({
  type: GENERATE_BLOG_TITLES_REQUEST,
});

export const generateBlogTitlesSuccess = titles => ({
  type: GENERATE_BLOG_TITLES_SUCCESS,
  payload: titles,
});

export const generateBlogTitlesError = error => ({
  type: GENERATE_BLOG_TITLES_ERROR,
  payload: error,
});

export const generateBlogsRequest = () => ({
  type: GENERATE_BLOGS_REQUEST,
});

export const generateBlogsSuccess = blogs => ({
  type: GENERATE_BLOGS_SUCCESS,
  payload: blogs,
});

export const generateBlogsError = error => ({
  type: GENERATE_BLOGS_ERROR,
  payload: error,
});

export const updateBlogRequest = blogId => ({
  type: UPDATE_BLOG_REQUEST,
  payload: blogId,
});

export const updateBlogSuccess = blog => ({
  type: UPDATE_BLOG_SUCCESS,
  payload: blog,
});

export const updateBlogError = (blogId, error) => ({
  type: UPDATE_BLOG_ERROR,
  payload: { id: blogId, error },
});

export const deleteBlogRequest = blogId => ({
  type: DELETE_BLOG_REQUEST,
  payload: blogId,
});

export const deleteBlogSuccess = blogId => ({
  type: DELETE_BLOG_SUCCESS,
  payload: blogId,
});

export const deleteBlogError = (blogId, error) => ({
  type: DELETE_BLOG_ERROR,
  payload: { id: blogId, error },
});

export const publishBlogRequest = blogId => ({
  type: PUBLISH_BLOG_REQUEST,
  payload: blogId,
});

export const publishBlogSuccess = blog => ({
  type: PUBLISH_BLOG_SUCCESS,
  payload: blog,
});

export const publishBlogError = (blogId, error) => ({
  type: PUBLISH_BLOG_ERROR,
  payload: { id: blogId, error },
});

export const retryStoreBlogTranslationsRequest = blogId => ({
  type: RETRY_STORE_BLOG_TRANSLATIONS_REQUEST,
  payload: blogId,
});

export const retryStoreBlogTranslationsSuccess = (blogId, blog, status) => ({
  type: RETRY_STORE_BLOG_TRANSLATIONS_SUCCESS,
  payload: { id: blogId, blog, status },
});

export const retryStoreBlogTranslationsError = (blogId, error) => ({
  type: RETRY_STORE_BLOG_TRANSLATIONS_ERROR,
  payload: { id: blogId, error },
});

export const updateListingBlogsRequest = () => ({
  type: UPDATE_LISTING_BLOGS_REQUEST,
});

export const updateListingBlogsSuccess = blogs => ({
  type: UPDATE_LISTING_BLOGS_SUCCESS,
  payload: blogs,
});

export const updateListingBlogsError = error => ({
  type: UPDATE_LISTING_BLOGS_ERROR,
  payload: error,
});

export const createBlogRequest = () => ({
  type: CREATE_BLOG_REQUEST,
});

export const createBlogSuccess = blog => ({
  type: CREATE_BLOG_SUCCESS,
  payload: blog,
});

export const createBlogError = error => ({
  type: CREATE_BLOG_ERROR,
  payload: error,
});

// ================ Thunks ================ //

// Fetch user listings (only IDs)
export const fetchUserListings = () => {
  return async (dispatch, getState, sdk) => {
    dispatch(fetchUserListingsRequest());

    try {
      const response = await sdk.ownListings.query({
        include: [],
        fields: ['id'],
        page: 1,
        perPage: 100,
      });

      const listings = response.data.data.map(listing => listing.id.uuid);
      dispatch(fetchListingBlogs(listings));
      // dispatch(fetchUserListingsSuccess(listings));
      // return listings;
    } catch (error) {
      console.error('Error fetching user listings:', error);
      const storableErr = storableError(error);
      dispatch(fetchUserListingsError(storableErr));
      return [];
    }
  };
};

// Fetch listing blogs based on listingId array
export const fetchListingBlogs = listingIds => {
  return async (dispatch, getState, sdk) => {
    dispatch(fetchListingBlogsRequest());

    try {
      if (!listingIds || listingIds.length === 0) {
        dispatch(fetchListingBlogsSuccess([]));
        return [];
      }

      // Fetch blogs for each listing ID using the existing API function
      const blogPromises = listingIds.map(listingId =>
        getBlogsByListingId(listingId).catch(error => {
          console.error(
            `Error fetching blogs for listing ${listingId}:`,
            error
          );
          return []; // Return empty array for failed requests
        })
      );

      const blogResults = await Promise.all(blogPromises);
      const blogs =
        Array.isArray(blogResults) && blogResults.length
          ? blogResults[0]?.data
          : [];

      // Flatten the array of arrays and remove duplicates.
      //
      // A failed request is turned into [] by the catch above, and a request that timed out or
      // came back as an error page rather than JSON lands here the same way, so this has to
      // cope with something that is not the shape a successful read returns (ticket 91).
      const { blogs: allBlogs, analytics } = (!Array.isArray(blogs) && blogs) || {};

      // A failed read means no listing blogs, which is an empty list, not undefined. This
      // value is kept in state and another reducer branch maps over it, so anything but an
      // array here is a crash somewhere else later rather than an error here (ticket 91).
      const listingBlogs = Array.isArray(allBlogs) ? allBlogs : [];

      dispatch(fetchListingBlogsSuccess(listingBlogs));
      // dispatch(fetchBlogsAnalytics(analytics));
      return listingBlogs;
    } catch (error) {
      console.error('Error fetching listing blogs:', error);
      const storableErr = storableError(error);
      dispatch(fetchListingBlogsError(storableErr));
      return [];
    }
  };
};

// Fetch store blogs by userId
export const fetchStoreBlogs = userId => {
  return async (dispatch, getState, sdk) => {
    dispatch(fetchStoreBlogsRequest());

    try {
      if (!userId) {
        dispatch(fetchStoreBlogsSuccess([]));
        return [];
      }

      const response = await getStoreBlogsByUserId(userId);
      const { blogs, analytics } = response.data || {
        blogs: [],
        analytics: null,
      };

      dispatch(fetchStoreBlogsSuccess(blogs));
      if (analytics) {
        dispatch(fetchStoreBlogsAnalyticsSuccess(analytics));
      }
      return blogs;
    } catch (error) {
      console.error('Error fetching store blogs:', error);
      const storableErr = storableError(error);
      dispatch(fetchStoreBlogsError(storableErr));
      return [];
    }
  };
};

// Update Store Blog - handles blog updates and profile update
export const updateStoreBlog = (formValues, currentUser) => {
  return async (dispatch, getState, sdk) => {
    dispatch(updateStoreBlogRequest());

    try {
      const { blogPosts } = formValues;

      // Filter out empty blog posts and validate
      const validBlogPosts = blogPosts.filter(
        post =>
          post.title &&
          post.title.trim() !== '' &&
          post.content &&
          post.content.trim() !== ''
      );

      // Prepare publicData payload
      const publicDataPayload = {
        storeBlog: validBlogPosts,
      };

      const payload = {
        publicData: publicDataPayload,
      };

      // Call updateProfile thunk from ProfileSettingsPage
      await dispatch(updateProfile(payload));

      dispatch(updateStoreBlogSuccess());
      return true;
    } catch (error) {
      console.error('Error updating store blog:', error);
      const storableErr = storableError(error);
      dispatch(updateStoreBlogError(storableErr));
      return false;
    }
  };
};

// Thunk for generating blog titles
export const requestGenerateBlogTitles = params => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(generateBlogTitlesRequest());
  try {
    const { data } = await generateStoreBlogTitleswithLabels(params);
    dispatch(generateBlogTitlesSuccess(data.blogTitles));
    return data.blogTitles;
  } catch (error) {
    dispatch(generateBlogTitlesError(error));
  }
};

// Thunk for generating blogs from selected titles
export const requestStoreGenerateBlogs = params => async dispatch => {
  dispatch(generateBlogsRequest());
  const locale =
    typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : 'en';
  params.locale = locale;

  try {
    const { data } = await generateStoreBlogs(params);
    dispatch(generateBlogsSuccess(data));
    return data;
  } catch (error) {
    dispatch(generateBlogsError(error));
  }
};

// Thunk for updating a blog
export const requestUpdateBlog = (blogId, update) => async dispatch => {
  dispatch(updateBlogRequest(blogId));
  try {
    const result = await updateStoreBlogPost(blogId, update);
    const blog = result.data || {};
    dispatch(updateBlogSuccess(blog));
    return blog;
  } catch (error) {
    console.error('Error updating blog:', error);
    dispatch(updateBlogError(blogId, error));
    throw error;
  }
};

// Thunk for deleting a blog
export const requestDeleteBlog = blogId => async dispatch => {
  dispatch(deleteBlogRequest(blogId));
  try {
    // You'll need to implement deleteBlogPost API call
    await deleteStoreBlogPostApi(blogId);
    dispatch(deleteBlogSuccess(blogId));
  } catch (error) {
    dispatch(deleteBlogError(blogId, error));
  }
};

// Thunk for publishing/unpublishing a blog
export const requestPublishBlog = blogId => async dispatch => {
  dispatch(publishBlogRequest(blogId));
  try {
    // You'll need to implement publishBlogPost API call
    const result = await publishStoreBlogPost(blogId);
    dispatch(publishBlogSuccess(result.data));
    return result.data;
  } catch (error) {
    dispatch(publishBlogError(blogId, error));
  }
};

export const requestRetryStoreBlogTranslations = blogId => async dispatch => {
  dispatch(retryStoreBlogTranslationsRequest(blogId));
  try {
    const result = await retryStoreBlogTranslations(blogId);
    const maybe = result?.data || result;
    const updated = maybe && maybe.data ? maybe.data : maybe;
    const hasTranslations =
      !!updated?.translations &&
      typeof updated.translations === 'object' &&
      Object.keys(updated.translations).length > 0;
    const status =
      hasTranslations || updated?.translationsStatus === 'succeeded'
        ? 'completed'
        : 'in_progress';
    dispatch(retryStoreBlogTranslationsSuccess(blogId, updated, status));
    return updated;
  } catch (error) {
    dispatch(retryStoreBlogTranslationsError(blogId, error));
    throw error;
  }
};

// Thunk for updating listing blogs
export const updateListingBlogs = (listingId, blogs) => {
  return async (dispatch, getState, sdk) => {
    dispatch(updateListingBlogsRequest());

    try {
      // Update each blog's showInStore status via API
      const updatePromises = blogs.map(blog =>
        updateBlogPost(blog._id, {
          showInStore: blog.showInStore,
          storeOrder: blog.storeOrder,
        })
          .then(response => response.data)
          .catch(error => {
            console.error(`Error updating blog ${blog._id}:`, error);
            return null;
          })
      );

      const results = await Promise.all(updatePromises);
      const successfulUpdates = results.filter(result => result !== null);
      const failedUpdatesCount = blogs.length - successfulUpdates.length;

      if (successfulUpdates.length > 0) {
        dispatch(updateListingBlogsSuccess(successfulUpdates));
      }

      if (failedUpdatesCount > 0) {
        dispatch(
          updateListingBlogsError(
            storableError(
              new Error(`Failed to update ${failedUpdatesCount} listing blogs`)
            )
          )
        );
      }

      return successfulUpdates;
    } catch (error) {
      console.error('Error updating listing blogs:', error);
      const storableErr = storableError(error);
      dispatch(updateListingBlogsError(storableErr));
      return [];
    }
  };
};

// Thunk for creating a new blog
export const requestCreateBlog = blogData => async dispatch => {
  dispatch(createBlogRequest());
  try {
    const payload = getStoreBlogSlug(blogData)
      ? blogData
      : { ...blogData, slug: buildStoreBlogSlug(blogData) };
    const result = await createStoreBlogPostApi(payload);
    const blog = result.data || {};
    dispatch(createBlogSuccess(blog));
    return blog;
  } catch (error) {
    console.error('Error creating blog:', error);
    dispatch(createBlogError(error));
    throw error;
  }
};

// Load initial data for Store Blog Page
export const loadData = () => {
  return async (dispatch, getState, sdk) => {
    return Promise.resolve(dispatch(fetchUserListings()));
  };
};

// ================ Selectors ================ //

export const getUpdateInProgress = state => {
  return state.StoreBlogPage.updateInProgress;
};

export const getUpdateError = state => state.StoreBlogPage.updateError;

export const getFetchUserListingsInProgress = state =>
  state.StoreBlogPage.fetchUserListingsInProgress;

export const getFetchUserListingsError = state =>
  state.StoreBlogPage.fetchUserListingsError;

export const getUserListings = state => state.StoreBlogPage.userListings;

export const getFetchListingBlogsInProgress = state =>
  state.StoreBlogPage.fetchListingBlogsInProgress;

export const getFetchListingBlogsError = state =>
  state.StoreBlogPage.fetchListingBlogsError;

export const getListingBlogs = state => state.StoreBlogPage.listingBlogs;

export const getFetchStoreBlogsInProgress = state =>
  state.StoreBlogPage.fetchStoreBlogsInProgress;

export const getFetchStoreBlogsError = state =>
  state.StoreBlogPage.fetchStoreBlogsError;

export const getStoreBlogs = state => state.StoreBlogPage.storeBlogs;

export const getStoreBlogsAnalytics = state =>
  state.StoreBlogPage.storeBlogsAnalytics;

export const getGenerateBlogTitlesInProgress = state =>
  state.StoreBlogPage.generateBlogTitlesInProgress;

export const getGenerateBlogTitlesError = state =>
  state.StoreBlogPage.generateBlogTitlesError;

export const getBlogTitles = state => state.StoreBlogPage.blogTitles;

export const getGenerateBlogsInProgress = state =>
  state.StoreBlogPage.generateBlogsInProgress;

export const getGenerateBlogsError = state =>
  state.StoreBlogPage.generateBlogsError;

export const getGeneratedBlogs = state => state.StoreBlogPage.generatedBlogs;

export const getUpdateBlogInProgress = state =>
  state.StoreBlogPage.updateBlogInProgress;

export const getUpdateBlogError = state => state.StoreBlogPage.updateBlogError;

export const getDeleteBlogInProgress = state =>
  state.StoreBlogPage.deleteBlogInProgress;

export const getDeleteBlogError = state => state.StoreBlogPage.deleteBlogError;

export const getPublishBlogInProgress = state =>
  state.StoreBlogPage.publishBlogInProgress;

export const getPublishBlogError = state =>
  state.StoreBlogPage.publishBlogError;

export const getRetryTranslationsInProgress = state =>
  state.StoreBlogPage.retryTranslationsInProgress;

export const getRetryTranslationsStatus = state =>
  state.StoreBlogPage.retryTranslationsStatus;

export const getRetryTranslationsError = state =>
  state.StoreBlogPage.retryTranslationsError;

export const getUpdateListingBlogsInProgress = state =>
  state.StoreBlogPage.updateListingBlogsInProgress;

export const getUpdateListingBlogsError = state =>
  state.StoreBlogPage.updateListingBlogsError;

export const getCreateBlogInProgress = state =>
  state.StoreBlogPage.createBlogInProgress;

export const getCreateBlogError = state => state.StoreBlogPage.createBlogError;
